import { lazy } from 'react';

import QALink from 'components/QALink';

import Auth from 'ux/Auth';
import Logout from 'ux/Auth/Logout';
import SupportTicketWorkOrderPage from 'ux/Customer/Support/SupportTicketWorkOrderPage';
import TenantEmployeeRequestPage from 'ux/Customer/Support/TenantEmployeeRequestPage';
import Page404 from 'ux/Page/404';
import Page500 from 'ux/Page/500';
import AboutUs from 'ux/Public/AboutUs';
import AddProperty from 'ux/Public/AddProperty';
import AnnualReport from 'ux/Public/AnnualReport';
import BlogArticle from 'ux/Public/Blog/Article';
import BlogLanding from 'ux/Public/Blog/Landing';
import Brokers from 'ux/Public/Brokers';
import CaseStudies from 'ux/Public/CaseStudies';
import CityPage from 'ux/Public/CityPage';
import CommercialRealEstate from 'ux/Public/CommercialRealEstate';
import Compare from 'ux/Public/Compare';
import CompareDetail from 'ux/Public/CompareDetail';
import PublicHome from 'ux/Public/Home';
import HowItWorks from 'ux/Public/HowItWorks';
import Listing from 'ux/Public/Listing';
import STBListing from 'ux/Public/Listing/STB';
import STBRequest from 'ux/Public/Listing/STB/STBRequest';
import Location from 'ux/Public/Location';
import NYCTechWeek from 'ux/Public/NYCTechWeek';
import NotificationPreferences from 'ux/Public/NotificationPreferences';
import OfficeRequest from 'ux/Public/OfficeRequest';
import Offsites from 'ux/Public/Offsites';
import Playbook from 'ux/Public/Playbook';
import PlaybookLandingPage from 'ux/Public/Playbook/PlaybookLandingPage';
import Press from 'ux/Public/Press';
import Privacy from 'ux/Public/Privacy';
import ReferralLanding from 'ux/Public/ReferralLanding';
import SFTechWeek from 'ux/Public/SFTechWeek';
import SlackIntegrationInstalled from 'ux/Public/SlackIntegrationInstalled';
import SlackOAuthCallback from 'ux/Public/SlackOAuthCallback';
import SlackUserOAuthCallback from 'ux/Public/SlackUserOAuthCallback';
import ServicesRequest from 'ux/Public/ServicesRequest';
import Terms from 'ux/Public/Terms';
import Testimonials from 'ux/Public/Testimonials';
import Search from 'ux/Search';
import SearchEntry from 'ux/Search/SearchEntry';
import AIAssistant from 'ux/Tenant/AIAssistant';
import CleaningServiceCheckoutPage from 'ux/Tenant/CleaningService/Onboarding/CleaningServiceCheckoutPage';
import CleaningServiceSetUp from 'ux/Tenant/CleaningService/Onboarding/CleaningServiceSetUp';
import TenantEmployeeComingSoon from 'ux/Tenant/ComingSoon';
import ConsumablesOnboardingSetPage from 'ux/Tenant/PantryRestocking/Onboarding/ConsumablesOnboardingSetPage';
import ConsumablesStartSubscriptionPage from 'ux/Tenant/PantryRestocking/Onboarding/ConsumablesStartSubscriptionPage';
import ConsumablesOrderPage from 'ux/Tenant/PantryRestocking/Orders/ConsumablesOrderPage';
import PaymentMethods from 'ux/Tenant/PaymentMethods';

import {
  ABOUT_US_PATH,
  ACCOUNT_PATH,
  ADD_ON_ORDERS_REDIRECT_PATH,
  ADD_ON_ORDERS_REDIRECT_SLUG_PATH,
  ADD_PROPERTY_PATH,
  ADMIN_PATH,
  AI_ASSISTANT_PATH,
  AI_ASSISTANT_SLUG_PATH,
  AI_OFFICE_ASSISTANT_PATH,
  ANNUAL_REPORT_PATH,
  AUTH_PATH,
  BLOG_ARTICLE_PATH,
  BLOG_PATH,
  BROKERS_PATH,
  CASE_STUDY_PATH,
  CITY_PAGE_SLUG_PATH,
  CLEANING_PATH,
  CLEANING_SERVICE_ONBOARDING_CHECKOUT_PATH,
  CLEANING_SERVICE_PATH,
  CLEANING_SERVICE_SET_UP_PATH,
  COMMERCIAL_REAL_ESTATE_PATH,
  COMPARE_DETAIL_SLUG_PATH,
  COMPARE_PATH,
  CONSUMABLES_CHECKOUT_PATH,
  CONSUMABLES_ONBOARDING_SET_PATH,
  CUSTOMER_ADD_FURNITURE_SLUG_PATH,
  CUSTOMER_CLEANING_REDIRECT_PATH,
  CUSTOMER_CLEANING_SLUG_PATH,
  CUSTOMER_EDIT_CLEANING_SCHEDULE_PATH,
  CUSTOMER_FURNITURE_SLUG_PATH,
  CUSTOMER_OFFICE_REQUEST_ID_PATH,
  CUSTOMER_OFFICE_REQUEST_PATH,
  CUSTOMER_OFFSITES_PATH,
  CUSTOMER_OFFSITES_SLUG_PATH,
  CUSTOMER_ORDERS_PATH,
  CUSTOMER_SERVICES_AND_AMENITIES_SLUG_PATH,
  CUSTOMER_SUPPORT_PATH,
  CUSTOMER_SUPPORT_SLUG_DETAILS_PATH,
  CUSTOMER_SUPPORT_SLUG_MESSAGES_PATH,
  CUSTOMER_SUPPORT_SLUG_PATH,
  CUSTOMER_SUPPORT_WORK_ORDER_SLUG_PATH,
  EMPLOYEE_REQUESTS_SLUG_PATH,
  DASHBOARD_PATH,
  FIVE_HUNDRED_PATH,
  FOUR_ZERO_FOUR_PATH,
  FURNITURE_CHECKOUT_PATH,
  FURNITURE_GET_STARTED_PATH,
  FURNITURE_PATH,
  FURNITURE_SHOP_PRODUCT_SET_SLUG_PATH,
  GFP_PATH,
  HOME_PATH,
  HOW_IT_WORKS_PATH,
  LANDLORD_DASHBOARD_PATH,
  LANDLORD_PAYMENTS_PATH,
  LISTING_PATH,
  LISTING_SLUG_PATH,
  LOCATION_SLUG_PATH,
  LOGOUT_PATH,
  MEMBERSHIP_ADD_ONS_SLUG_PATH,
  MEMBERSHIP_PATH,
  MEMBERSHIP_PLAN_SLUG_PATH,
  NOTIFICATION_PREFERENCES_TOKEN_PATH,
  NYC_TECH_WEEK_PATH,
  OFFICE_REQUEST_PATH,
  OFFICE_SEO_ASSISTANT_NYC_PATH,
  OFFICE_SEO_ASSISTANT_SF_PATH,
  OFFICE_SEO_CLEANING_NYC_PATH,
  OFFICE_SEO_CLEANING_SF_PATH,
  OFFICE_SEO_FURNITURE_NYC_PATH,
  OFFICE_SEO_FURNITURE_SF_PATH,
  OFFICE_SEO_INTERNET_NYC_PATH,
  OFFICE_SEO_INTERNET_SF_PATH,
  OFFICE_SEO_PANTRY_NYC_PATH,
  OFFICE_SEO_PANTRY_SF_PATH,
  OFFICE_SEO_COMPARISON_PATH,
  OFFICE_SEO_HUB_PATH,
  OFFICE_SEO_SERVICES_CITY_PATH,
  OFFICE_SEO_DEEP_CLEANING_SF_PATH,
  OFFICE_SEO_DEEP_CLEANING_NYC_PATH,
  OFFICE_SEO_CARPET_CLEANING_SF_PATH,
  OFFICE_SEO_CARPET_CLEANING_NYC_PATH,
  OFFICE_SEO_WINDOW_CLEANING_SF_PATH,
  OFFICE_SEO_WINDOW_CLEANING_NYC_PATH,
  OFFICE_SEO_GLASS_CLEANING_SF_PATH,
  OFFICE_SEO_GLASS_CLEANING_NYC_PATH,
  OFFICE_SEO_WASTE_RECYCLING_SF_PATH,
  OFFICE_SEO_WASTE_RECYCLING_NYC_PATH,
  OFFICE_SEO_PANTRY_INVENTORY_SF_PATH,
  OFFICE_SEO_PANTRY_INVENTORY_NYC_PATH,
  OFFICE_SEO_COFFEE_SERVICE_SF_PATH,
  OFFICE_SEO_COFFEE_SERVICE_NYC_PATH,
  OFFICE_SEO_WATER_SERVICE_SF_PATH,
  OFFICE_SEO_WATER_SERVICE_NYC_PATH,
  OFFICE_SEO_TEAM_LUNCH_SF_PATH,
  OFFICE_SEO_TEAM_LUNCH_NYC_PATH,
  OFFICE_SEO_BREAKFAST_CATERING_SF_PATH,
  OFFICE_SEO_BREAKFAST_CATERING_NYC_PATH,
  OFFICE_SEO_INDIVIDUAL_MEALS_SF_PATH,
  OFFICE_SEO_INDIVIDUAL_MEALS_NYC_PATH,
  OFFICE_SEO_AD_HOC_CATERING_SF_PATH,
  OFFICE_SEO_AD_HOC_CATERING_NYC_PATH,
  OFFICE_SEO_HAPPY_HOUR_SF_PATH,
  OFFICE_SEO_HAPPY_HOUR_NYC_PATH,
  OFFICE_SEO_CONFERENCE_ROOM_AV_SF_PATH,
  OFFICE_SEO_CONFERENCE_ROOM_AV_NYC_PATH,
  OFFICE_SEO_NETWORK_INSTALLATION_SF_PATH,
  OFFICE_SEO_NETWORK_INSTALLATION_NYC_PATH,
  OFFICE_SEO_NETWORK_MANAGEMENT_SF_PATH,
  OFFICE_SEO_NETWORK_MANAGEMENT_NYC_PATH,
  OFFICE_SEO_CABLE_MANAGEMENT_SF_PATH,
  OFFICE_SEO_CABLE_MANAGEMENT_NYC_PATH,
  OFFICE_SEO_ROOM_BOOKING_SF_PATH,
  OFFICE_SEO_ROOM_BOOKING_NYC_PATH,
  OFFICE_SEO_PRINTING_SETUP_SF_PATH,
  OFFICE_SEO_PRINTING_SETUP_NYC_PATH,
  OFFICE_SEO_INTERIOR_DESIGN_SF_PATH,
  OFFICE_SEO_INTERIOR_DESIGN_NYC_PATH,
  OFFICE_SEO_OFFICE_MURALS_SF_PATH,
  OFFICE_SEO_OFFICE_MURALS_NYC_PATH,
  OFFICE_SEO_OFFICE_PAINTING_SF_PATH,
  OFFICE_SEO_OFFICE_PAINTING_NYC_PATH,
  OFFICE_SEO_GLASS_FROSTING_SF_PATH,
  OFFICE_SEO_GLASS_FROSTING_NYC_PATH,
  OFFICE_SEO_OFFICE_SIGNAGE_SF_PATH,
  OFFICE_SEO_OFFICE_SIGNAGE_NYC_PATH,
  OFFICE_SEO_CARE_ROOM_SF_PATH,
  OFFICE_SEO_CARE_ROOM_NYC_PATH,
  OFFICE_SEO_FURNITURE_ASSEMBLY_SF_PATH,
  OFFICE_SEO_FURNITURE_ASSEMBLY_NYC_PATH,
  OFFICE_SEO_LAYOUT_CHANGE_SF_PATH,
  OFFICE_SEO_LAYOUT_CHANGE_NYC_PATH,
  OFFICE_SEO_OFFICE_PLANTS_SF_PATH,
  OFFICE_SEO_OFFICE_PLANTS_NYC_PATH,
  OFFICE_SEO_KEYLESS_ACCESS_SF_PATH,
  OFFICE_SEO_KEYLESS_ACCESS_NYC_PATH,
  OFFICE_SEO_ALARM_SYSTEMS_SF_PATH,
  OFFICE_SEO_ALARM_SYSTEMS_NYC_PATH,
  OFFICE_SEO_SECURITY_CAMERAS_SF_PATH,
  OFFICE_SEO_SECURITY_CAMERAS_NYC_PATH,
  OFFICE_SEO_KEYPADS_SF_PATH,
  OFFICE_SEO_KEYPADS_NYC_PATH,
  OFFICE_SEO_LOCKBOXES_SF_PATH,
  OFFICE_SEO_LOCKBOXES_NYC_PATH,
  OFFICE_SEO_VISITOR_MANAGEMENT_SF_PATH,
  OFFICE_SEO_VISITOR_MANAGEMENT_NYC_PATH,
  OFFICE_SEO_BUSINESS_INSURANCE_SF_PATH,
  OFFICE_SEO_BUSINESS_INSURANCE_NYC_PATH,
  OFFICE_SEO_ELECTRICAL_SERVICES_SF_PATH,
  OFFICE_SEO_ELECTRICAL_SERVICES_NYC_PATH,
  OFFICE_SEO_HVAC_SF_PATH,
  OFFICE_SEO_HVAC_NYC_PATH,
  OFFICE_SEO_PLUMBING_SF_PATH,
  OFFICE_SEO_PLUMBING_NYC_PATH,
  OFFICE_SEO_PEST_CONTROL_SF_PATH,
  OFFICE_SEO_PEST_CONTROL_NYC_PATH,
  OFFICE_SEO_OFFICE_MOVING_SF_PATH,
  OFFICE_SEO_OFFICE_MOVING_NYC_PATH,
  OFFICE_SEO_MOUNTING_INSTALLATION_SF_PATH,
  OFFICE_SEO_MOUNTING_INSTALLATION_NYC_PATH,
  OFFSITES_PATH,
  PANTRY_ORDERS_PATH,
  PANTRY_ORDER_SLUG_PATH,
  PANTRY_PATH,
  PANTRY_SHOP_PATH,
  PANTRY_SUBSCRIPTION_EDIT_PATH,
  PANTRY_SUBSCRIPTION_PATH,
  PAYMENTS_PATH,
  SMART_PANTRY_PATH,
  PAYMENT_SUMMARY_SLUG_PATH,
  PLAYBOOK_PATH,
  PRESS_PATH,
  PRIVACY_PATH,
  PROPERTIES_PATH,
  PUBLIC_FURNITURE_PATH,
  QA_LINK,
  REFERRALS_PATH,
  REFERRAL_LANDING_CODE_PATH,
  RESTOCKING_PATH,
  ROOT_PATH,
  SEARCH_ENTRY_PATH,
  SEARCH_PATH,
  SEARCH_PATH_DEPRECATED,
  SERVICES_REQUEST_PATH,
  SLACK_INTEGRATION_INSTALLED_PATH,
  SLACK_OAUTH_CALLBACK_PATH,
  SLACK_USER_OAUTH_CALLBACK_PATH,
  SERVICE_CATEGORIES_PATH,
  SF_TECH_WEEK_PATH,
  STB_REQUEST_PATH,
  STB_REQUEST_SLUG_PATH,
  TECH_MANAGEMENT_PATH,
  TENANT_ADMIN_BUILDING_INTERNET_PLANS_CHECKOUT_PATH,
  TENANT_ADMIN_BUILDING_INTERNET_PLANS_PATH,
  TENANT_ADMIN_PATH,
  TENANT_EMPLOYEE_COMING_SOON_PATH,
  TENANT_ONBOARDING_CHECKLIST_PATH,
  TENANT_PAYMENT_METHODS_PATH,
  TERMS_PATH,
  TESTIMONIALS_PATH,
  VENDOR_NETWORK_PATH,
  VENDOR_PATH
} from './paths';
import { Route } from './types';

const ChecklistPage = lazy(() => import('ux/Tenant/Onboarding/ChecklistPage'));
const Admin = lazy(() => import('ux/Admin'));
const Account = lazy(() => import('ux/Customer/Account'));
const CustomerOffsites = lazy(() => import('ux/Customer/Offsites'));
const CustomerOffsite = lazy(() => import('ux/Customer/Offsites/CustomerOffsite'));
const Orders = lazy(() => import('ux/Customer/Orders'));
const OrderRedirect = lazy(() => import('ux/Customer/Orders/OrderRedirect'));
const OrdersRedirect = lazy(() => import('ux/Customer/Orders/OrdersRedirect'));
const PaymentSummary = lazy(() => import('ux/Payments/PaymentSummary'));
const Properties = lazy(() => import('ux/Properties'));
const CustomerOfficeRequest = lazy(() => import('ux/Customer/OfficeRequest'));
const Payments = lazy(() => import('ux/Payments'));
const Dashboard = lazy(() => import('ux/Dashboard'));
const PantryRestocking = lazy(() => import('ux/Tenant/PantryRestocking'));
const SmartPantryPage = lazy(() => import('ux/Tenant/SmartPantry'));
const Vendor = lazy(() => import('ux/Vendor'));
const Landlord = lazy(() => import('ux/Landlord'));
const AppRedirect = lazy(() => import('ux/Customer/AppRedirect'));
const Referrals = lazy(() => import('ux/Customer/Referrals'));
const Cleaning = lazy(() => import('ux/Customer/ServicesAndAmenities/Cleaning'));
const CleaningRedirect = lazy(() => import('ux/Customer/ServicesAndAmenities/Cleaning/CleaningRedirect'));
const Furniture = lazy(() => import('ux/Customer/ServicesAndAmenities/Furniture'));
const ServicesAndAmenities = lazy(() => import('ux/Customer/ServicesAndAmenities'));
const AddFurniturePage = lazy(() => import('ux/Customer/ServicesAndAmenities/Furniture/AddFurniture/AddFurniturePage'));
const EditCleaningSchdule = lazy(() => import('ux/Customer/ServicesAndAmenities/Cleaning/EditCleaningSchedule'));
const CustomerOfficeRequestsList = lazy(() => import('ux/Customer/OfficeRequest/CustomerOfficeRequestsList'));
const OfficesRedirect = lazy(() => import('ux/Customer/Offices/OfficesRedirect'));
const Membership = lazy(() => import('ux/Customer/Membership'));
const MembershipPlan = lazy(() => import('ux/Customer/Membership/MembershipPlan'));
const MembershipAddOnsPage = lazy(() => import('ux/Customer/Membership/MembershipAddOnsPage'));
const CustomerSupport = lazy(() => import('ux/Customer/Support'));
const CustomerSupportPage = lazy(() => import('ux/Customer/Support/Page'));
const ConsumablesEditSubscriptionPage = lazy(
  () => import('ux/Tenant/PantryRestocking/Subscription/ConsumablesEditSubscriptionPage')
);
const FurnitureCheckoutPage = lazy(() => import('ux/Tenant/FurnitureAndEquipment/FurnitureCheckoutPage'));
const GFPLandingPage = lazy(() => import('ux/Public/GFPLandingPage'));
const CleaningService = lazy(() => import('ux/Tenant/CleaningService'));
const TenantAdmin = lazy(() => import('ux/Tenant/TenantAdmin'));
const InternetQuotesPage = lazy(() => import('ux/Tenant/TenantAdmin/Building/Internet/InternetQuotesPage'));
const InternetCheckoutPage = lazy(() => import('ux/Tenant/TenantAdmin/Building/Internet/InternetCheckoutPage'));
const FurnitureAndEquipment = lazy(() => import('ux/Tenant/FurnitureAndEquipment'));
const FurnitureGetStartedPage = lazy(() => import('ux/Tenant/FurnitureAndEquipment/FurnitureGetStartedPage'));
const LandlordPayments = lazy(() => import('ux/Landlord/Financials/Payments'));
const ProductSetUI = lazy(() => import('ux/Tenant/FurnitureAndEquipment/ProductSetUI'));
const ServicesIndex = lazy(() => import('ux/Tenant/Services/ServicesIndex'));
const TechManagementPage = lazy(() => import('ux/Public/TechManagement'));
const CleaningPage = lazy(() => import('ux/Public/Cleaning'));
const RestockingPage = lazy(() => import('ux/Public/Restocking'));
const PublicFurniturePage = lazy(() => import('ux/Public/Furniture'));
const AiOfficeAssistant = lazy(() => import('ux/Public/AiOfficeAssistant'));
const VendorNetwork = lazy(() => import('ux/Public/VendorNetwork'));
const OfficeSeoCleaning = lazy(() => import('ux/Public/OfficeSeo/Cleaning'));
const OfficeSeoPantryRestocking = lazy(() => import('ux/Public/OfficeSeo/PantryRestocking'));
const OfficeSeoInternet = lazy(() => import('ux/Public/OfficeSeo/Internet'));
const OfficeSeoOfficeAssistant = lazy(() => import('ux/Public/OfficeSeo/OfficeAssistant'));
const OfficeSeoOfficeFurniture = lazy(() => import('ux/Public/OfficeSeo/OfficeFurniture'));
const OfficeSeoComparison = lazy(() => import('ux/Public/OfficeSeo/OfficeSeoComparison'));
const OfficeSeoHub = lazy(() => import('ux/Public/OfficeSeo/OfficeSeoHub'));
const OfficeSeoServiceCity = lazy(() => import('ux/Public/OfficeSeo/OfficeSeoServiceCity'));
const OfficeSeoDeepCleaning = lazy(() => import('ux/Public/OfficeSeo/DeepCleaning'));
const OfficeSeoCarpetCleaning = lazy(() => import('ux/Public/OfficeSeo/CarpetCleaning'));
const OfficeSeoWindowCleaning = lazy(() => import('ux/Public/OfficeSeo/WindowCleaning'));
const OfficeSeoGlassConferenceRoom = lazy(() => import('ux/Public/OfficeSeo/GlassConferenceRoom'));
const OfficeSeoWasteRecycling = lazy(() => import('ux/Public/OfficeSeo/WasteRecycling'));
const OfficeSeoPantryInventory = lazy(() => import('ux/Public/OfficeSeo/PantryInventory'));
const OfficeSeoCoffeeService = lazy(() => import('ux/Public/OfficeSeo/CoffeeService'));
const OfficeSeoWaterService = lazy(() => import('ux/Public/OfficeSeo/WaterService'));
const OfficeSeoTeamLunch = lazy(() => import('ux/Public/OfficeSeo/TeamLunch'));
const OfficeSeoBreakfastCatering = lazy(() => import('ux/Public/OfficeSeo/BreakfastCatering'));
const OfficeSeoIndividualMeals = lazy(() => import('ux/Public/OfficeSeo/IndividualMeals'));
const OfficeSeoAdHocCatering = lazy(() => import('ux/Public/OfficeSeo/AdHocCatering'));
const OfficeSeoHappyHour = lazy(() => import('ux/Public/OfficeSeo/HappyHour'));
const OfficeSeoConferenceRoomAv = lazy(() => import('ux/Public/OfficeSeo/ConferenceRoomAv'));
const OfficeSeoNetworkInstallation = lazy(() => import('ux/Public/OfficeSeo/NetworkInstallation'));
const OfficeSeoNetworkManagement = lazy(() => import('ux/Public/OfficeSeo/NetworkManagement'));
const OfficeSeoCableManagement = lazy(() => import('ux/Public/OfficeSeo/CableManagement'));
const OfficeSeoRoomBooking = lazy(() => import('ux/Public/OfficeSeo/RoomBooking'));
const OfficeSeoPrintingSetup = lazy(() => import('ux/Public/OfficeSeo/PrintingSetup'));
const OfficeSeoInteriorDesign = lazy(() => import('ux/Public/OfficeSeo/InteriorDesign'));
const OfficeSeoOfficeMurals = lazy(() => import('ux/Public/OfficeSeo/OfficeMurals'));
const OfficeSeoOfficePainting = lazy(() => import('ux/Public/OfficeSeo/OfficePainting'));
const OfficeSeoGlassFrosting = lazy(() => import('ux/Public/OfficeSeo/GlassFrosting'));
const OfficeSeoOfficeSignage = lazy(() => import('ux/Public/OfficeSeo/OfficeSignage'));
const OfficeSeoCareRoom = lazy(() => import('ux/Public/OfficeSeo/CareRoom'));
const OfficeSeoFurnitureAssembly = lazy(() => import('ux/Public/OfficeSeo/FurnitureAssembly'));
const OfficeSeoLayoutChange = lazy(() => import('ux/Public/OfficeSeo/LayoutChange'));
const OfficeSeoOfficePlants = lazy(() => import('ux/Public/OfficeSeo/OfficePlants'));
const OfficeSeoKeylessAccess = lazy(() => import('ux/Public/OfficeSeo/KeylessAccess'));
const OfficeSeoAlarmSystems = lazy(() => import('ux/Public/OfficeSeo/AlarmSystems'));
const OfficeSeoSecurityCameras = lazy(() => import('ux/Public/OfficeSeo/SecurityCameras'));
const OfficeSeoKeypads = lazy(() => import('ux/Public/OfficeSeo/Keypads'));
const OfficeSeoLockboxes = lazy(() => import('ux/Public/OfficeSeo/Lockboxes'));
const OfficeSeoVisitorManagement = lazy(() => import('ux/Public/OfficeSeo/VisitorManagement'));
const OfficeSeoBusinessInsurance = lazy(() => import('ux/Public/OfficeSeo/BusinessInsurance'));
const OfficeSeoElectricalServices = lazy(() => import('ux/Public/OfficeSeo/ElectricalServices'));
const OfficeSeoHvac = lazy(() => import('ux/Public/OfficeSeo/Hvac'));
const OfficeSeoPlumbing = lazy(() => import('ux/Public/OfficeSeo/Plumbing'));
const OfficeSeoPestControl = lazy(() => import('ux/Public/OfficeSeo/PestControl'));
const OfficeSeoOfficeMoving = lazy(() => import('ux/Public/OfficeSeo/OfficeMoving'));
const OfficeSeoMountingInstallation = lazy(() => import('ux/Public/OfficeSeo/MountingInstallation'));

export const ROUTES: Route[] = [
  { path: TENANT_EMPLOYEE_COMING_SOON_PATH, Component: TenantEmployeeComingSoon, requiredRole: 'tenant', exact: true },
  {
    path: TENANT_ADMIN_BUILDING_INTERNET_PLANS_PATH,
    Component: InternetQuotesPage,
    requiredRole: 'tenantAdmin',
    exact: true,
    customLayout: true,
    showMobileBottomNav: false
  },
  {
    path: TENANT_ADMIN_BUILDING_INTERNET_PLANS_CHECKOUT_PATH,
    Component: InternetCheckoutPage,
    requiredRole: 'tenantAdmin',
    exact: true,
    customLayout: true,
    showMobileBottomNav: false
  },
  { path: TENANT_ADMIN_PATH, Component: TenantAdmin, requiredRole: 'customerAdmin' },
  { path: AI_ASSISTANT_PATH, Component: AIAssistant, requiredRole: 'tenantAdmin', exact: true },
  { path: AI_ASSISTANT_SLUG_PATH, Component: AIAssistant, requiredRole: 'tenantAdmin' },
  { path: TENANT_PAYMENT_METHODS_PATH, Component: PaymentMethods, requiredRole: 'customerAdmin' },
  { path: PANTRY_PATH, Component: PantryRestocking, requiredRole: 'customerAdmin', exact: true },
  { path: PANTRY_SHOP_PATH, Component: PantryRestocking, requiredRole: 'customerAdmin' },
  {
    path: PANTRY_SUBSCRIPTION_EDIT_PATH,
    Component: ConsumablesEditSubscriptionPage,
    requiredRole: 'customerAdmin',
    exact: true
  },
  { path: PANTRY_SUBSCRIPTION_PATH, Component: PantryRestocking, requiredRole: 'customerAdmin' },
  { path: PANTRY_ORDERS_PATH, Component: PantryRestocking, requiredRole: 'customerAdmin', exact: true },
  { path: SMART_PANTRY_PATH, Component: SmartPantryPage, requiredRole: 'customerAdmin', exact: true },
  { path: PANTRY_ORDER_SLUG_PATH, Component: ConsumablesOrderPage, requiredRole: 'customerAdmin' },
  {
    path: CONSUMABLES_CHECKOUT_PATH,
    Component: ConsumablesStartSubscriptionPage,
    requiredRole: 'customerAdmin',
    customLayout: true
  },
  {
    path: CONSUMABLES_ONBOARDING_SET_PATH,
    Component: ConsumablesOnboardingSetPage,
    requiredRole: 'customerAdmin'
  },
  {
    path: FURNITURE_CHECKOUT_PATH,
    Component: FurnitureCheckoutPage,
    requiredRole: 'tenantAdmin',
    exact: true,
    customLayout: true
  },
  { path: FURNITURE_SHOP_PRODUCT_SET_SLUG_PATH, Component: ProductSetUI, requiredRole: 'tenantAdmin', exact: true },
  { path: FURNITURE_GET_STARTED_PATH, Component: FurnitureGetStartedPage, requiredRole: 'tenantAdmin', exact: true },
  { path: FURNITURE_PATH, Component: FurnitureAndEquipment, requiredRole: 'tenantAdmin' },
  { path: SERVICE_CATEGORIES_PATH, Component: ServicesIndex, requiredRole: 'tenantAdmin' },
  {
    path: TENANT_ONBOARDING_CHECKLIST_PATH,
    Component: ChecklistPage,
    requiredRole: 'tenantAdmin'
  },
  {
    path: CLEANING_SERVICE_SET_UP_PATH,
    Component: CleaningServiceSetUp,
    requiredRole: 'tenantAdmin',
    customLayout: true
  },
  {
    path: CLEANING_SERVICE_ONBOARDING_CHECKOUT_PATH,
    Component: CleaningServiceCheckoutPage,
    requiredRole: 'tenantAdmin',
    customLayout: true,
    exact: true
  },
  { path: CLEANING_SERVICE_PATH, Component: CleaningService, requiredRole: 'tenantAdmin' },

  { path: ACCOUNT_PATH, Component: Account, requiredRole: 'user', sideBarIsExpandable: false },
  {
    path: ADMIN_PATH,
    Component: Admin,
    requiredRole: 'superAdmin',
    hideFooter: true
  },
  { path: AUTH_PATH, Component: Auth, hideFooter: true, hideHeader: true, customLayout: true, waitForUserLoad: true },
  {
    path: CUSTOMER_OFFICE_REQUEST_PATH,
    Component: CustomerOfficeRequestsList,
    requiredRole: 'employee',
    exact: true
  },
  {
    path: CUSTOMER_OFFICE_REQUEST_ID_PATH,
    Component: CustomerOfficeRequest,
    requiredRole: 'employee',
    exact: true
  },
  {
    path: CUSTOMER_EDIT_CLEANING_SCHEDULE_PATH,
    Component: EditCleaningSchdule,
    requiredRole: 'hasCustomerAdminPlans',
    exact: true,
    showMobileBottomNav: false
  },
  {
    path: CUSTOMER_CLEANING_SLUG_PATH,
    Component: Cleaning,
    requiredRole: 'hasCustomerAdminPlans',
    exact: true
  },
  { path: CUSTOMER_FURNITURE_SLUG_PATH, Component: Furniture, requiredRole: 'hasCustomerAdminPlans', exact: true },
  {
    path: CUSTOMER_CLEANING_REDIRECT_PATH,
    Component: CleaningRedirect,
    requiredRole: 'hasCustomerAdminPlans',
    exact: true
  },
  {
    path: CUSTOMER_ADD_FURNITURE_SLUG_PATH,
    Component: AddFurniturePage,
    requiredRole: 'hasCustomerAdminPlans',
    exact: true,
    showMobileBottomNav: false
  },
  {
    path: CUSTOMER_SERVICES_AND_AMENITIES_SLUG_PATH,
    Component: ServicesAndAmenities,
    requiredRole: 'hasCustomerAdminPlans',
    exact: true
  },
  {
    path: CUSTOMER_SUPPORT_PATH,
    requiredRole: 'hasCustomerAdminPlans',
    Component: CustomerSupport,
    exact: true
  },
  {
    path: CUSTOMER_SUPPORT_WORK_ORDER_SLUG_PATH,
    requiredRole: 'hasCustomerAdminPlans',
    Component: SupportTicketWorkOrderPage,
    exact: true
  },
  {
    path: CUSTOMER_SUPPORT_SLUG_MESSAGES_PATH,
    requiredRole: 'hasCustomerAdminPlans',
    Component: CustomerSupportPage,
    exact: true
  },
  {
    path: CUSTOMER_SUPPORT_SLUG_DETAILS_PATH,
    requiredRole: 'hasCustomerAdminPlans',
    Component: CustomerSupportPage,
    exact: true
  },
  {
    path: CUSTOMER_SUPPORT_SLUG_PATH,
    requiredRole: 'hasCustomerAdminPlans',
    Component: CustomerSupportPage,
    exact: true
  },
  {
    path: EMPLOYEE_REQUESTS_SLUG_PATH,
    requiredRole: 'hasCustomerAdminPlans',
    Component: TenantEmployeeRequestPage,
    exact: true
  },
  { path: PAYMENT_SUMMARY_SLUG_PATH, Component: PaymentSummary, requiredRole: 'hasCustomerAdminPlans' },
  { path: PAYMENTS_PATH, Component: Payments, requiredRole: 'hasCustomerAdminPlans' },
  { path: DASHBOARD_PATH, Component: Dashboard, requiredRole: 'employee' },
  {
    path: PROPERTIES_PATH,
    Component: Properties,
    requiredRole: 'hasBuildingUserRoles',
    sideBarIsExpandable: false
  },
  { path: VENDOR_PATH, Component: Vendor, requiredRole: 'vendor' },
  { path: LANDLORD_DASHBOARD_PATH, Component: Landlord, requiredRole: 'landlord' },
  { path: LANDLORD_PAYMENTS_PATH, Component: LandlordPayments, requiredRole: 'landlord' },
  {
    path: SEARCH_PATH,
    exact: true,
    Component: Search,
    customLayout: true,
    hasFooterMargin: false,
    waitForGoogleMapsLoad: true,
    waitForUserLoad: true
  },
  {
    path: SEARCH_PATH_DEPRECATED,
    Component: Search,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: SEARCH_ENTRY_PATH,
    Component: SearchEntry,
    customLayout: true,
    hasFooterMargin: false,
    hideHeader: true,
    hideFooter: true,
    waitForAnalyticsLoad: false,
    waitForGoogleMapsLoad: false
  },
  {
    path: LISTING_SLUG_PATH,
    Component: Listing,
    hasHeaderCta: false,
    waitForUserLoad: true
  },
  {
    path: LISTING_PATH,
    Component: Listing,
    hasHeaderCta: false,
    waitForUserLoad: true
  },
  {
    path: HOME_PATH,
    Component: AppRedirect,
    requiredRole: 'user',
    exact: true
  },
  { path: CITY_PAGE_SLUG_PATH, Component: CityPage },
  { path: LOCATION_SLUG_PATH, Component: Location, cmsSlug: 'location', hasFooterMargin: false },
  {
    path: ABOUT_US_PATH,
    Component: AboutUs,
    exact: true,
    cmsSlug: 'about-us'
  },
  {
    path: BLOG_PATH,
    Component: BlogLanding,
    exact: true
  },
  {
    path: ANNUAL_REPORT_PATH,
    Component: AnnualReport,
    exact: true,
    hasFooterMargin: false
  },
  { path: BLOG_ARTICLE_PATH, Component: BlogArticle, exact: true },
  { path: CASE_STUDY_PATH, Component: CaseStudies, hasFooterMargin: false },
  {
    path: COMMERCIAL_REAL_ESTATE_PATH,
    Component: CommercialRealEstate,
    exact: true,
    hasFooterMargin: false,
    hasHeaderCta: false
  },
  {
    path: COMPARE_DETAIL_SLUG_PATH,
    Component: CompareDetail,
    exact: true,
    cmsSlug: 'compare-detail',
    hasFooterMargin: false
  },
  {
    path: COMPARE_PATH,
    Component: Compare,
    exact: true,
    cmsSlug: 'compare',
    hasFooterMargin: false
  },
  {
    path: ROOT_PATH,
    Component: PublicHome,
    exact: true,
    customLayout: true,
    hasFooterMargin: false,
    hideFooter: true,
    waitForAnalyticsLoad: false
  },
  {
    path: HOW_IT_WORKS_PATH,
    Component: HowItWorks,
    exact: true,
    hasFooterMargin: false
  },
  {
    path: TECH_MANAGEMENT_PATH,
    Component: TechManagementPage,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: CLEANING_PATH,
    Component: CleaningPage,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: RESTOCKING_PATH,
    Component: RestockingPage,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: PUBLIC_FURNITURE_PATH,
    Component: PublicFurniturePage,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: AI_OFFICE_ASSISTANT_PATH,
    Component: AiOfficeAssistant,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: VENDOR_NETWORK_PATH,
    Component: VendorNetwork,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_COMPARISON_PATH,
    Component: OfficeSeoComparison,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_HUB_PATH,
    Component: OfficeSeoHub,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_SERVICES_CITY_PATH,
    Component: OfficeSeoServiceCity,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_CLEANING_SF_PATH,
    Component: OfficeSeoCleaning,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_CLEANING_NYC_PATH,
    Component: OfficeSeoCleaning,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_PANTRY_SF_PATH,
    Component: OfficeSeoPantryRestocking,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_PANTRY_NYC_PATH,
    Component: OfficeSeoPantryRestocking,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_INTERNET_SF_PATH,
    Component: OfficeSeoInternet,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_INTERNET_NYC_PATH,
    Component: OfficeSeoInternet,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_ASSISTANT_SF_PATH,
    Component: OfficeSeoOfficeAssistant,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_ASSISTANT_NYC_PATH,
    Component: OfficeSeoOfficeAssistant,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_FURNITURE_SF_PATH,
    Component: OfficeSeoOfficeFurniture,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_FURNITURE_NYC_PATH,
    Component: OfficeSeoOfficeFurniture,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_DEEP_CLEANING_SF_PATH,
    Component: OfficeSeoDeepCleaning,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_DEEP_CLEANING_NYC_PATH,
    Component: OfficeSeoDeepCleaning,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_CARPET_CLEANING_SF_PATH,
    Component: OfficeSeoCarpetCleaning,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_CARPET_CLEANING_NYC_PATH,
    Component: OfficeSeoCarpetCleaning,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_WINDOW_CLEANING_SF_PATH,
    Component: OfficeSeoWindowCleaning,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_WINDOW_CLEANING_NYC_PATH,
    Component: OfficeSeoWindowCleaning,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_GLASS_CLEANING_SF_PATH,
    Component: OfficeSeoGlassConferenceRoom,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_GLASS_CLEANING_NYC_PATH,
    Component: OfficeSeoGlassConferenceRoom,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_WASTE_RECYCLING_SF_PATH,
    Component: OfficeSeoWasteRecycling,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_WASTE_RECYCLING_NYC_PATH,
    Component: OfficeSeoWasteRecycling,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_PANTRY_INVENTORY_SF_PATH,
    Component: OfficeSeoPantryInventory,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_PANTRY_INVENTORY_NYC_PATH,
    Component: OfficeSeoPantryInventory,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_COFFEE_SERVICE_SF_PATH,
    Component: OfficeSeoCoffeeService,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_COFFEE_SERVICE_NYC_PATH,
    Component: OfficeSeoCoffeeService,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_WATER_SERVICE_SF_PATH,
    Component: OfficeSeoWaterService,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_WATER_SERVICE_NYC_PATH,
    Component: OfficeSeoWaterService,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_TEAM_LUNCH_SF_PATH,
    Component: OfficeSeoTeamLunch,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_TEAM_LUNCH_NYC_PATH,
    Component: OfficeSeoTeamLunch,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_BREAKFAST_CATERING_SF_PATH,
    Component: OfficeSeoBreakfastCatering,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_BREAKFAST_CATERING_NYC_PATH,
    Component: OfficeSeoBreakfastCatering,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_INDIVIDUAL_MEALS_SF_PATH,
    Component: OfficeSeoIndividualMeals,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_INDIVIDUAL_MEALS_NYC_PATH,
    Component: OfficeSeoIndividualMeals,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_AD_HOC_CATERING_SF_PATH,
    Component: OfficeSeoAdHocCatering,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_AD_HOC_CATERING_NYC_PATH,
    Component: OfficeSeoAdHocCatering,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_HAPPY_HOUR_SF_PATH,
    Component: OfficeSeoHappyHour,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_HAPPY_HOUR_NYC_PATH,
    Component: OfficeSeoHappyHour,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_CONFERENCE_ROOM_AV_SF_PATH,
    Component: OfficeSeoConferenceRoomAv,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_CONFERENCE_ROOM_AV_NYC_PATH,
    Component: OfficeSeoConferenceRoomAv,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_NETWORK_INSTALLATION_SF_PATH,
    Component: OfficeSeoNetworkInstallation,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_NETWORK_INSTALLATION_NYC_PATH,
    Component: OfficeSeoNetworkInstallation,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_NETWORK_MANAGEMENT_SF_PATH,
    Component: OfficeSeoNetworkManagement,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_NETWORK_MANAGEMENT_NYC_PATH,
    Component: OfficeSeoNetworkManagement,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_CABLE_MANAGEMENT_SF_PATH,
    Component: OfficeSeoCableManagement,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_CABLE_MANAGEMENT_NYC_PATH,
    Component: OfficeSeoCableManagement,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_ROOM_BOOKING_SF_PATH,
    Component: OfficeSeoRoomBooking,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_ROOM_BOOKING_NYC_PATH,
    Component: OfficeSeoRoomBooking,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_PRINTING_SETUP_SF_PATH,
    Component: OfficeSeoPrintingSetup,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_PRINTING_SETUP_NYC_PATH,
    Component: OfficeSeoPrintingSetup,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_INTERIOR_DESIGN_SF_PATH,
    Component: OfficeSeoInteriorDesign,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_INTERIOR_DESIGN_NYC_PATH,
    Component: OfficeSeoInteriorDesign,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_OFFICE_MURALS_SF_PATH,
    Component: OfficeSeoOfficeMurals,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_OFFICE_MURALS_NYC_PATH,
    Component: OfficeSeoOfficeMurals,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_OFFICE_PAINTING_SF_PATH,
    Component: OfficeSeoOfficePainting,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_OFFICE_PAINTING_NYC_PATH,
    Component: OfficeSeoOfficePainting,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_GLASS_FROSTING_SF_PATH,
    Component: OfficeSeoGlassFrosting,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_GLASS_FROSTING_NYC_PATH,
    Component: OfficeSeoGlassFrosting,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_OFFICE_SIGNAGE_SF_PATH,
    Component: OfficeSeoOfficeSignage,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_OFFICE_SIGNAGE_NYC_PATH,
    Component: OfficeSeoOfficeSignage,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_CARE_ROOM_SF_PATH,
    Component: OfficeSeoCareRoom,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_CARE_ROOM_NYC_PATH,
    Component: OfficeSeoCareRoom,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_FURNITURE_ASSEMBLY_SF_PATH,
    Component: OfficeSeoFurnitureAssembly,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_FURNITURE_ASSEMBLY_NYC_PATH,
    Component: OfficeSeoFurnitureAssembly,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_LAYOUT_CHANGE_SF_PATH,
    Component: OfficeSeoLayoutChange,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_LAYOUT_CHANGE_NYC_PATH,
    Component: OfficeSeoLayoutChange,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_OFFICE_PLANTS_SF_PATH,
    Component: OfficeSeoOfficePlants,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_OFFICE_PLANTS_NYC_PATH,
    Component: OfficeSeoOfficePlants,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_KEYLESS_ACCESS_SF_PATH,
    Component: OfficeSeoKeylessAccess,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_KEYLESS_ACCESS_NYC_PATH,
    Component: OfficeSeoKeylessAccess,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_ALARM_SYSTEMS_SF_PATH,
    Component: OfficeSeoAlarmSystems,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_ALARM_SYSTEMS_NYC_PATH,
    Component: OfficeSeoAlarmSystems,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_SECURITY_CAMERAS_SF_PATH,
    Component: OfficeSeoSecurityCameras,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_SECURITY_CAMERAS_NYC_PATH,
    Component: OfficeSeoSecurityCameras,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_KEYPADS_SF_PATH,
    Component: OfficeSeoKeypads,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_KEYPADS_NYC_PATH,
    Component: OfficeSeoKeypads,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_LOCKBOXES_SF_PATH,
    Component: OfficeSeoLockboxes,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_LOCKBOXES_NYC_PATH,
    Component: OfficeSeoLockboxes,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_VISITOR_MANAGEMENT_SF_PATH,
    Component: OfficeSeoVisitorManagement,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_VISITOR_MANAGEMENT_NYC_PATH,
    Component: OfficeSeoVisitorManagement,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_BUSINESS_INSURANCE_SF_PATH,
    Component: OfficeSeoBusinessInsurance,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_BUSINESS_INSURANCE_NYC_PATH,
    Component: OfficeSeoBusinessInsurance,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_ELECTRICAL_SERVICES_SF_PATH,
    Component: OfficeSeoElectricalServices,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_ELECTRICAL_SERVICES_NYC_PATH,
    Component: OfficeSeoElectricalServices,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_HVAC_SF_PATH,
    Component: OfficeSeoHvac,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_HVAC_NYC_PATH,
    Component: OfficeSeoHvac,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_PLUMBING_SF_PATH,
    Component: OfficeSeoPlumbing,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_PLUMBING_NYC_PATH,
    Component: OfficeSeoPlumbing,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_PEST_CONTROL_SF_PATH,
    Component: OfficeSeoPestControl,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_PEST_CONTROL_NYC_PATH,
    Component: OfficeSeoPestControl,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_OFFICE_MOVING_SF_PATH,
    Component: OfficeSeoOfficeMoving,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_OFFICE_MOVING_NYC_PATH,
    Component: OfficeSeoOfficeMoving,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_MOUNTING_INSTALLATION_SF_PATH,
    Component: OfficeSeoMountingInstallation,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: OFFICE_SEO_MOUNTING_INSTALLATION_NYC_PATH,
    Component: OfficeSeoMountingInstallation,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: PRESS_PATH,
    Component: Press,
    exact: true,
    cmsSlug: 'press'
  },
  {
    path: PRIVACY_PATH,
    Component: Privacy,
    exact: true,
    cmsSlug: 'privacy-policy'
  },
  {
    path: TERMS_PATH,
    Component: Terms,
    exact: true,
    cmsSlug: 'terms-of-service'
  },
  { path: PLAYBOOK_PATH, Component: PlaybookLandingPage, exact: true, hasFooterMargin: false },
  { path: PLAYBOOK_PATH, Component: Playbook, hideHeader: true, hideFooter: true, customLayout: true },
  {
    path: REFERRAL_LANDING_CODE_PATH,
    Component: ReferralLanding,
    hasHeaderCta: false,
    hasFooterMargin: false,
    customLayout: true
  },
  {
    path: NOTIFICATION_PREFERENCES_TOKEN_PATH,
    Component: NotificationPreferences,
    exact: true
  },
  {
    path: OFFICE_REQUEST_PATH,
    Component: OfficeRequest,
    hideFooter: true,
    hideHeader: true,
    customLayout: true
  },
  {
    path: SERVICES_REQUEST_PATH,
    Component: ServicesRequest,
    hideFooter: true,
    hideHeader: true,
    customLayout: true
  },
  {
    path: '/app/offices',
    Component: OfficesRedirect,
    exact: true,
    requiredRole: 'employee'
  },
  {
    path: MEMBERSHIP_PATH,
    Component: Membership,
    exact: true,
    requiredRole: 'hasCustomerAdminPlans'
  },
  { path: MEMBERSHIP_PLAN_SLUG_PATH, Component: MembershipPlan, exact: true, requiredRole: 'hasCustomerAdminPlans' },
  {
    path: MEMBERSHIP_ADD_ONS_SLUG_PATH,
    Component: MembershipAddOnsPage,
    exact: true,
    requiredRole: 'hasCustomerAdminPlans'
  },
  {
    path: CUSTOMER_OFFSITES_PATH,
    Component: CustomerOffsites,
    exact: true,
    requiredRole: 'user'
  },
  {
    path: CUSTOMER_OFFSITES_SLUG_PATH,
    Component: CustomerOffsite,
    exact: true,
    requiredRole: 'employee'
  },
  {
    path: ADD_ON_ORDERS_REDIRECT_PATH,
    Component: OrdersRedirect,
    exact: true,
    requiredRole: 'hasCustomerAdminPlans'
  },
  {
    path: ADD_ON_ORDERS_REDIRECT_SLUG_PATH,
    Component: OrderRedirect,
    exact: true,
    requiredRole: 'hasCustomerAdminPlans'
  },
  {
    path: CUSTOMER_ORDERS_PATH,
    Component: Orders,
    exact: true,
    requiredRole: 'hasCustomerAdminPlans'
  },
  {
    path: REFERRALS_PATH,
    Component: Referrals,
    exact: true,
    requiredRole: 'employee'
  },
  { path: QA_LINK, Component: QALink, waitForUserLoad: true },
  { path: FIVE_HUNDRED_PATH, Component: Page500 },
  { path: FOUR_ZERO_FOUR_PATH, Component: Page404 },
  {
    path: SF_TECH_WEEK_PATH,
    Component: SFTechWeek,
    customLayout: true,
    exact: true
  },
  {
    path: NYC_TECH_WEEK_PATH,
    Component: NYCTechWeek,
    customLayout: true,
    exact: true
  },
  {
    path: TESTIMONIALS_PATH,
    Component: Testimonials,
    customLayout: true,
    hasFooterMargin: false,
    exact: true
  },
  {
    path: BROKERS_PATH,
    Component: Brokers,
    exact: true,
    customLayout: true,
    hasFooterMargin: false
  },
  {
    path: STB_REQUEST_PATH,
    Component: STBRequest,
    hideFooter: true,
    hideHeader: true,
    exact: true,
    customLayout: true
  },
  {
    path: STB_REQUEST_SLUG_PATH,
    Component: STBListing,
    hasFooterMargin: false
  },
  { path: OFFSITES_PATH, Component: Offsites, exact: true, cmsSlug: 'offsites', hasFooterMargin: false },
  { path: ADD_PROPERTY_PATH, Component: AddProperty, customLayout: true, hideFooter: true, hideHeader: true },
  { path: LOGOUT_PATH, Component: Logout, exact: true },
  {
    path: GFP_PATH,
    Component: GFPLandingPage,
    customLayout: true,
    hasFooterMargin: false,
    exact: true
  },
  {
    path: SLACK_INTEGRATION_INSTALLED_PATH,
    Component: SlackIntegrationInstalled,
    customLayout: true,
    hasFooterMargin: false,
    exact: true
  },
  {
    path: SLACK_OAUTH_CALLBACK_PATH,
    Component: SlackOAuthCallback,
    customLayout: true,
    hasFooterMargin: false,
    exact: true
  },
  {
    path: SLACK_USER_OAUTH_CALLBACK_PATH,
    Component: SlackUserOAuthCallback,
    customLayout: true,
    hasFooterMargin: false,
    exact: true
  }
];
